import { render } from "./CreateProductView.vue?vue&type=template&id=4dac9818"
import script from "./CreateProductView.vue?vue&type=script&lang=js"
export * from "./CreateProductView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__